import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormBuilderComponent} from './form-builder/form-builder.component';
import {FieldsDefaultListComponent} from './form-builder/fields-default-list/fields-default-list.component';
import {FormBlockComponent} from './form-builder/form-block/form-block.component';
import {FlexLayoutModule} from '@Common/widgets/flex-layout/flex-layout.module';
import {MatAngularModule} from '@Common/mat-angular.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {DmSelectDialogComponent} from './form-builder/shared/select-dialog/select-dialog.component';
import {DmConfirmDialogComponent} from './form-builder/shared/confirm-dialog/confirm-dialog.component';
import {FormActionsComponent} from './form-builder/shared/form-actions/form-actions.component';
import {FormModalComponent} from './form-builder/shared/form-modal/form-modal.component';
import {TextInputComponent, TextInputDialogComponent} from './form-builder/form-control/text-input';
import {TextAreaDialogComponent, TextAreaInputComponent} from './form-builder/form-control/text-area-input';
import {CheckboxRadioInputComponent, CheckboxRadioInputDialogComponent} from './form-builder/form-control/checkbox-radio-input';
import {DateInputComponent, DateInputDialogComponent} from './form-builder/form-control/date-input';
import {FormRenderComponent} from './form-render/form-render.component';
import {FormStatesComponent} from './form-states/form-states.component';
import {PhoneInputComponent, PhoneInputDialogComponent} from './form-builder/form-control/phone-input';
import {EmailInputComponent, EmailInputDialogComponent} from './form-builder/form-control/email-input';
import {ResponseStateInstructionComponent} from './response-states/response-state-instruction.component';
import {ResponseStateMessageComponent} from './response-states/response-state-message/response-state-message.component';
import {CommonModuleP8} from '@Common/common-p8.module';
import {SelectInputComponent, SelectInputDialogComponent} from './form-builder/form-control/select-input';
import {EmailGenericComponent} from './form-builder/shared/email-generic/email-generic.component';
import {DmBlockModalComponent} from './form-builder/shared/block-modal/dm-block-modal.component';
import {ControlActionsComponent} from './form-builder/shared/control-actions/control-actions.component';
import {ChoiceListComponent} from './form-builder/form-control/common/choice-list/choice-list.component';
import {LabelRequiredComponentActionsComponent} from './form-builder/form-control/common/label-required-actions/label-required-component-actions.component';
import {FileInputComponent, FileInputDialogComponent} from './form-builder/form-control/file-input';
import { FormRenderDateComponent } from './form-render/form-render-date/form-render-date.component';
import { StateValidationComponent } from './form-states/state-validation/state-validation.component';
import {CommonDematModule} from '../../common.module';
import { FormRenderLabelComponent } from './form-render/form-render-label/form-render-label.component';
import { SvcCmpInputComponent } from './form-builder/form-control/svc-cmp-input/svc-cmp-input.component';
import { SvcCmpInputDialogComponent } from './form-builder/form-control/svc-cmp-input/svc-cmp-input-dialog.component';
import { FormRenderSvccmpComponent } from './form-render/form-render-svccmp/form-render-svccmp.component';
import {LabelInputComponent, LabelInputDialogComponent} from './form-builder/form-control/label-input';
import {QuillModule} from 'ngx-quill';
import {AvisInputComponent, AvisInputDialogComponent} from './form-builder/form-control/avis-input';
import { FormRenderAvisComponent } from './form-render/form-render-avis/form-render-avis.component';
import {NeoModule} from "@Common/neo-components/neo.module";
import { ModalInstructionMotifComponent } from './modal-instruction-motif/modal-instruction-motif.component';
import { FormCategorieComponent } from './form-builder/shared/form-categorie/form-categorie.component';
import { ModalCategorieComponent } from './form-builder/shared/form-categorie/cat-modal/modal-categorie/modal-categorie.component';

@NgModule({
    imports: [
        CommonModule,
        CommonModuleP8,
        FlexLayoutModule,
        MatAngularModule,
        FormsModule,
        ReactiveFormsModule,
        DragDropModule,
        CommonDematModule,
        QuillModule.forRoot(),
        NeoModule
    ],
    declarations: [
        FormBuilderComponent,
        FieldsDefaultListComponent,
        FormBlockComponent,
        DmConfirmDialogComponent,
        DmSelectDialogComponent,
        FormActionsComponent,
        FormModalComponent,
        FormRenderComponent,
        FormStatesComponent,
        ResponseStateInstructionComponent,
        ResponseStateMessageComponent,
        EmailGenericComponent,
        DmBlockModalComponent,
        ControlActionsComponent,
        LabelRequiredComponentActionsComponent,
        ChoiceListComponent,
        TextInputComponent, TextInputDialogComponent,
        TextAreaInputComponent, TextAreaDialogComponent,
        SelectInputComponent, SelectInputDialogComponent,
        PhoneInputComponent, PhoneInputDialogComponent,
        EmailInputComponent, EmailInputDialogComponent,
        DateInputComponent, DateInputDialogComponent,
        CheckboxRadioInputComponent, CheckboxRadioInputDialogComponent, FormRenderDateComponent,
        FileInputComponent, FileInputDialogComponent, StateValidationComponent, FormRenderLabelComponent,
        SvcCmpInputComponent, SvcCmpInputDialogComponent, FormRenderSvccmpComponent, LabelInputComponent, LabelInputDialogComponent,
        AvisInputComponent, AvisInputDialogComponent, FormRenderAvisComponent, ModalInstructionMotifComponent, FormCategorieComponent, ModalCategorieComponent,
    ],
  exports: [
    FormBuilderComponent,
    FieldsDefaultListComponent,
    FormBlockComponent,
    FormActionsComponent,
    FormRenderComponent,
    FormStatesComponent,
    ResponseStateInstructionComponent,
    ControlActionsComponent,
    LabelRequiredComponentActionsComponent,
    ChoiceListComponent,
    TextInputComponent, TextInputDialogComponent,
    TextAreaInputComponent, TextAreaDialogComponent,
    SelectInputComponent, SelectInputDialogComponent,
    PhoneInputComponent, PhoneInputDialogComponent,
    EmailInputComponent, EmailInputDialogComponent,
    DateInputComponent, DateInputDialogComponent,
    CheckboxRadioInputComponent, CheckboxRadioInputDialogComponent,
    FileInputComponent, FileInputDialogComponent,
    LabelInputComponent, LabelInputDialogComponent,
    AvisInputComponent, AvisInputDialogComponent, FormCategorieComponent,ModalCategorieComponent
  ]
})
export class FormBuilderModule {
}

